module.exports = __webpack_public_path__ + "static/img/1810_8.4c948ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1810_8.jpg
// module id = u+xL
// module chunks = 1